// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"rMpegy","themeThumbnail":"GVK9QY"};